import { css, styled } from "@vebox/etui-system";
import { Div, DivProps } from "@vebox/etui-system-elements";
import { Theme } from "@vebox/etui-themes";

interface SuggestionsContainerProps extends DivProps {
	maxContainerHeight?: string;
}

export const SuggestionsContainer = styled(Div)`
    position: absolute;
    width: calc(100% - 2px);
    overflow: auto;
    max-height: ${(props: SuggestionsContainerProps) =>
			props.maxContainerHeight || "210px"};
    top: 48px;
    border-top: none;
    ${({ theme }: SuggestionsContainerProps) => {
			const th = theme as Theme;
			return css`
            font-family: ${th.typography.fontFamily};
            font-size: ${th.typography.fontSizeBase};
            font-weight: ${th.typography.fontWeightRegular};
            line-height: ${th.typography.lineHeightBase};
            color: ${th.palette.text.primary};
            border: 1px solid ${th.palette.grey[100]};
            box-shadow: ${th.shadows[3]};
            background-color: ${th.palette.common.white};
        `;
		}};
    clip-path: polygon(-50% 0, 150% 0, 150% 150%, -50% 150%);
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    z-index: 100;
`;
